import React from 'react'
import { View } from 'react-native'

import PropTypes from 'prop-types'

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from '../ServiceCard/ServiceCard.style'

import { loadingConfig, shimmerPlaceholderConfig } from './ServiceCard.LoadingConfig'

const renderLoadingCards = (numberOfLoadingCards, theme) => {
  const loadingCards = []
  for (let i = 0; i < numberOfLoadingCards; i++) {
    loadingCards.push(
      <View style={styles.container(theme)} key={i}>
        <Shimmer
          config={loadingConfig(theme)}
          shimmerPlaceholderConfig={shimmerPlaceholderConfig}
        />
      </View>,
    )
  }
  return loadingCards
}

const ServiceCardLoading = ({ numberOfCards }) => {
  const theme = useTheme()
  return renderLoadingCards(numberOfCards, theme)
}

ServiceCardLoading.defaultProps = {
  numberOfCards: 3,
}

ServiceCardLoading.propTypes = {
  numberOfCards: PropTypes.number,
}

export default ServiceCardLoading
